export const SITUACION_INMUEBLE_MODELO_180 = {
  EXCEPTO_PAIS_VASCO_Y_NAVARRA: 1,
  PAIS_VASCO: 2,
  NAVARRA: 3,
  SITUACIONES_ANTERIORES_SIN_REFERENCIA_CATASTRAL: 4,
} as const

export type SituacionInmuebleModelo180Type =
  (typeof SITUACION_INMUEBLE_MODELO_180)[keyof typeof SITUACION_INMUEBLE_MODELO_180]
